// Autogenerated. Do not alter manually. Script: "audience_tracker"
import 'babel-polyfill';

var Logger = require('/home/luka/Desktop/dev/spinview/web-scripts/src/logger/logger.js').default;
var KrPanoClient = require('/home/luka/Desktop/dev/spinview/web-scripts/src/krpano_client/krpano_client.js').default;
var KrPanoDebugger = require('/home/luka/Desktop/dev/spinview/web-scripts/src/krpano_debugger/krpano_debugger.js').default;
var IdleDetector = require('/home/luka/Desktop/dev/spinview/web-scripts/src/idle_detector/idle_detector.js').default;
var SceneObserver = require('/home/luka/Desktop/dev/spinview/web-scripts/src/scene_observer/scene_observer.js').default;
var VrModeObserver = require('/home/luka/Desktop/dev/spinview/web-scripts/src/vr_mode_observer/vr_mode_observer.js').default;
var QueryUserProvider = require('/home/luka/Desktop/dev/spinview/web-scripts/src/query_user_provider/query_user_provider.js').default;
var QueryCustomDataProvider = require('/home/luka/Desktop/dev/spinview/web-scripts/src/query_custom_data_provider/query_custom_data_provider.js').default;
var AudienceTrackerApi = require('/home/luka/Desktop/dev/spinview/web-scripts/src/audience_tracker_api/audience_tracker_api.js').default;
var AudienceTracker = require('/home/luka/Desktop/dev/spinview/web-scripts/src/audience_tracker/audience_tracker.js').default;
var KrPanoInsights = require('/home/luka/Desktop/dev/spinview/web-scripts/src/krpano_insights_renderer/krpano_insights.js').default;

(function (container) {

	container.SPINVIEW_OPTIONS = container.SPINVIEW_OPTIONS || {};

	// Create "Logger"
	if (container.logger) {
		throw new Error('Service "logger" already exists in the container. Check your script tags!');
	}
	container.Logger_options = assign({
	"verbosity": 2
}, container.SPINVIEW_OPTIONS.Logger);
	container.logger = new Logger(Logger_options, container);

	// Create "KrPanoClient"
	if (container.krPanoClient) {
		throw new Error('Service "krPanoClient" already exists in the container. Check your script tags!');
	}
	container.KrPanoClient_options = assign({}, container.SPINVIEW_OPTIONS.KrPanoClient);
	container.krPanoClient = new KrPanoClient(KrPanoClient_options, container);

	// Create "KrPanoDebugger"
	if (container.krPanoDebugger) {
		throw new Error('Service "krPanoDebugger" already exists in the container. Check your script tags!');
	}
	container.KrPanoDebugger_options = assign({}, container.SPINVIEW_OPTIONS.KrPanoDebugger);
	container.krPanoDebugger = new KrPanoDebugger(KrPanoDebugger_options, container);

	// Create "IdleDetector"
	if (container.idleDetector) {
		throw new Error('Service "idleDetector" already exists in the container. Check your script tags!');
	}
	container.IdleDetector_options = assign({}, container.SPINVIEW_OPTIONS.IdleDetector);
	container.idleDetector = new IdleDetector(IdleDetector_options, container);

	// Create "SceneObserver"
	if (container.sceneObserver) {
		throw new Error('Service "sceneObserver" already exists in the container. Check your script tags!');
	}
	container.SceneObserver_options = assign({}, container.SPINVIEW_OPTIONS.SceneObserver);
	container.sceneObserver = new SceneObserver(SceneObserver_options, container);

	// Create "VrModeObserver"
	if (container.vrModeObserver) {
		throw new Error('Service "vrModeObserver" already exists in the container. Check your script tags!');
	}
	container.VrModeObserver_options = assign({}, container.SPINVIEW_OPTIONS.VrModeObserver);
	container.vrModeObserver = new VrModeObserver(VrModeObserver_options, container);

	// Create "QueryUserProvider"
	if (container.userProvider) {
		throw new Error('Service "userProvider" already exists in the container. Check your script tags!');
	}
	container.QueryUserProvider_options = assign({}, container.SPINVIEW_OPTIONS.QueryUserProvider);
	container.userProvider = new QueryUserProvider(QueryUserProvider_options, container);

	// Create "QueryCustomDataProvider"
	if (container.customDataProvider) {
		throw new Error('Service "customDataProvider" already exists in the container. Check your script tags!');
	}
	container.QueryCustomDataProvider_options = assign({}, container.SPINVIEW_OPTIONS.QueryCustomDataProvider);
	container.customDataProvider = new QueryCustomDataProvider(QueryCustomDataProvider_options, container);

	// Create "AudienceTrackerApi"
	if (container.trackerApi) {
		throw new Error('Service "trackerApi" already exists in the container. Check your script tags!');
	}
	container.AudienceTrackerApi_options = assign({}, container.SPINVIEW_OPTIONS.AudienceTrackerApi);
	container.trackerApi = new AudienceTrackerApi(AudienceTrackerApi_options, container);

	// Create "AudienceTracker"
	if (container.audienceTracker) {
		throw new Error('Service "audienceTracker" already exists in the container. Check your script tags!');
	}
	container.AudienceTracker_options = assign({}, container.SPINVIEW_OPTIONS.AudienceTracker);
	container.audienceTracker = new AudienceTracker(AudienceTracker_options, container);

	// Create "KrPanoInsights"
	if (container.krPanoInsights) {
		throw new Error('Service "krPanoInsights" already exists in the container. Check your script tags!');
	}
	container.KrPanoInsights_options = assign({}, container.SPINVIEW_OPTIONS.KrPanoInsights);
	container.krPanoInsights = new KrPanoInsights(KrPanoInsights_options, container);

	initialize([
		container.krPanoClient.init,
		container.krPanoDebugger.init,
		container.idleDetector.init,
		container.sceneObserver.init,
		container.vrModeObserver.init,
		container.audienceTracker.init,
		container.krPanoInsights.init,
	]);

	function assign(source, target) {
		if (!target) {
			return source;
		}

		for (var key in target) {
			if (target.hasOwnProperty && target.hasOwnProperty(key) && target[key] !== undefined) {
				source[key] = target[key];
			}
		}
		return source;
	}


	function initialize(fns) {
		var index = 0;
		next();

		function next() {
			if (index >= fns.length) {
				return;
			}
			if (fns[index].length > 0) {
				fns[index](callback);
			} else {
				fns[index]();
				callback();
			}
		}

		function callback(err) {
			if (err) {
				if (!err._logged) {
					console.error(err);
				}
			}
			index++;
			next();
		}
	}

})(window);
